import { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/api";

const ContentContext = createContext({ get: (key, fallback) => fallback, refresh: () => {} });

export function ContentProvider({ children }) {
  const [overrides, setOverrides] = useState({});

  const refresh = useCallback(() => {
    return axios
      .get(`${API}/content`)
      .then((r) => setOverrides(r.data?.overrides || {}))
      .catch(() => {});
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const get = useCallback((key, fallback = "") => overrides[key] ?? fallback, [overrides]);

  return <ContentContext.Provider value={{ get, refresh }}>{children}</ContentContext.Provider>;
}

export const useContent = () => useContext(ContentContext);
